export const ADFOX_ID = 4;
